"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.OpenFeed = void 0;
var _react = _interopRequireDefault(require("react"));
var _appShellApis = require("@icis/app-shell-apis");
var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));
var _ActivityFeed = _interopRequireDefault(require("./components/ActivityFeed.component"));
var _styles = require("./styles");
var _getAppConfig = _interopRequireDefault(require("../../../../../../constants/getAppConfig"));
var _Functionality = require("../Functionality.style");
class OpenFeed extends _react.default.PureComponent {
  constructor() {
    super(...arguments);
    this.handleButtonClick = () => {
      const {
        setClickedItem,
        selected
      } = this.props;
      if (selected) {
        this.onNavItemDeselected();
      } else {
        this.sendTrackAction();
        setClickedItem(this.props.menuItemId);
      }
    };
    this.sendTrackAction = () => (0, _appShellApis.trackAction)({
      gwa_account: (0, _getAppConfig.default)().analytics.account,
      gwa_siteSection3: 'activity feed',
      gwa_siteSection4: 'activity feed opened',
      gwa_contentTitle: 'activity feed opened',
      gwa_pageName: 'subscriber|website|activity feed|activity feed opened',
      gwa_contentHierarchy: 'subscriber|website|activity feed|activity feed opened',
      // @ts-ignore
      gwa_authstatus: 'logged in'
    });
    this.onNavItemDeselected = () => {
      const {
        setClickedItem,
        navItemRef
      } = this.props;
      setClickedItem(null);
      navItemRef.blur();
    };
  }
  /**
   * Handles a click outside the nav dropdown component.
   * Closes dropdown if it's open.
   */
  handleClickOutside() {
    const {
      selected
    } = this.props;
    const isWalkmePopUpVisible = document.querySelector(".walkme-custom-flow-1156562");
    if (selected && !isWalkmePopUpVisible) {
      this.onNavItemDeselected();
    }
  }
  render() {
    const {
      selected,
      setRef
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_styles.Container, null, /*#__PURE__*/_react.default.createElement(_styles.Button, {
      id: "nav-active-feed-btn",
      type: "button",
      onClick: this.handleButtonClick,
      ref: setRef(),
      "aria-expanded": selected /* istanbul ignore next */ ? 'true' : 'false',
      "data-walkmeid": "navItem-activity-feed"
    }, /*#__PURE__*/_react.default.createElement(_Functionality.NavItemLinkWrapper, {
      clickable: true,
      selected: selected,
      isSelectable: true
    }, this.props.children)), /*#__PURE__*/_react.default.createElement(_ActivityFeed.default, {
      isAfOpen: selected
    }));
  }
}
exports.OpenFeed = OpenFeed;
var _default = exports.default = (0, _reactClickOutside.default)(OpenFeed);